import { render, staticRenderFns } from "./BrandActivity.vue?vue&type=template&id=78d985fa&"
import script from "./BrandActivity.vue?vue&type=script&lang=js&"
export * from "./BrandActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports